
export default function Solucao() {
  return null;
}
